import React, { createContext, useContext, useState } from "react";
const GrammarContext = createContext();

export default function GrammarProvider({ children }) {
  const [originalGrammar, setOriginalGrammar] = useState([]);
  const [grammarCreatedDate, setGrammarCreatedDate] = useState(null);
  const [grammarName, setGrammarName] = useState(null);
  const [responseOriginalGrammar, setResponseOriginalGrammar] = useState("");
  const [isActiveDialogHistoricalGrammar, setActiveDialogHistoricalGrammar] =
    useState(false);
  const [isActiveDialogHowToUseGrammar, setActiveDialogHowToUseGrammar] =
    useState(false);
  const [openByClickCYK, setOpenByClickCYK] = useState(false);
  const [openByClickLeftMost, setOpenByClickLeftMost] = useState(false);
  const [openByClickAmbiguity, setOpenByClickAmbiguity] = useState(false);
  const [isActiveDialogImportGrammar, setActiveDialogImportGrammar] =
    useState(false);
  return (
    <GrammarContext.Provider
      value={{
        originalGrammar,
        setOriginalGrammar,
        grammarName,
        setGrammarName,
        grammarCreatedDate,
        setGrammarCreatedDate,
        responseOriginalGrammar,
        setResponseOriginalGrammar,
        isActiveDialogHistoricalGrammar,
        setActiveDialogHistoricalGrammar,
        openByClickCYK,
        setOpenByClickCYK,
        openByClickLeftMost,
        setOpenByClickLeftMost,
        openByClickAmbiguity,
        setOpenByClickAmbiguity,
        isActiveDialogImportGrammar,
        setActiveDialogImportGrammar,
        isActiveDialogHowToUseGrammar,
        setActiveDialogHowToUseGrammar,
      }}
    >
      {children}
    </GrammarContext.Provider>
  );
}

export function useGrammar() {
  const context = useContext(GrammarContext);
  const {
    originalGrammar,
    setOriginalGrammar,
    grammarName,
    setGrammarName,
    grammarCreatedDate,
    setGrammarCreatedDate,
    responseOriginalGrammar,
    setResponseOriginalGrammar,
    isActiveDialogHistoricalGrammar,
    setActiveDialogHistoricalGrammar,
    openByClickCYK,
    setOpenByClickCYK,
    openByClickLeftMost,
    setOpenByClickLeftMost,
    openByClickAmbiguity,
    setOpenByClickAmbiguity,
    isActiveDialogImportGrammar,
    setActiveDialogImportGrammar,
    isActiveDialogHowToUseGrammar,
    setActiveDialogHowToUseGrammar,
  } = context;
  return {
    originalGrammar,
    setOriginalGrammar,
    grammarName,
    setGrammarName,
    grammarCreatedDate,
    setGrammarCreatedDate,
    responseOriginalGrammar,
    setResponseOriginalGrammar,
    isActiveDialogHistoricalGrammar,
    setActiveDialogHistoricalGrammar,
    openByClickCYK,
    setOpenByClickCYK,
    openByClickLeftMost,
    setOpenByClickLeftMost,
    openByClickAmbiguity,
    setOpenByClickAmbiguity,
    isActiveDialogImportGrammar,
    setActiveDialogImportGrammar,
    isActiveDialogHowToUseGrammar,
    setActiveDialogHowToUseGrammar,
  };
}
